// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"19892dde","2641":"8cfe1493"}[chunkId] + ".chunk.css";
};